import { FC } from 'react';
import { NotFound } from '~/views/organisms/not.found';

export const PageNotFound: FC = () => {
    return <NotFound />;
};
